import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { AutocompleteDTO, AutocompleteOptions, CheckBoxOptions, DatePickerOptions, DropdownOptions, FilterItem, FilterType, ForceDirection, InputType, PagingOptions, PickerType, SelectMode, StartView, TextBoxOptions } from 'bbsf-controls';
import { ImpersonationRuleModel } from '../../shared/models/ImpersonationRuleModels/ImpersonationRuleModel';
import { UsersIDRequestModel } from '../../shared/models/UserModels/UsersIDRequestModel';
import { ImpersonationRuleService } from './../../shared/Services/ImpersonationRuleService.service';
import { PageInfoService } from '../../../_metronic/core/services/page-info.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AuthService, UtilityService, BBSFTranslateService, EnvironmentService } from 'bbsf-utilities';

@Component({
  selector: 'lib-impersonation-rules',
  templateUrl: './impersonation-rules.component.html'
})
export class ImpersonationRulesComponent implements OnInit {
  SubheaderTitle = this.utilityService.getResourceValue('ImpersonationRules');
  

  ShowToolbar = true; ShowbreadCrumb = false;
  ApiUrl = "/api/admin/ImpersonationRule/"
  searchTextBox: TextBoxOptions;
  TextInputFilter: FilterItem;
  ImpersonationForm = new FormGroup({});
  showFilter: boolean = false;
  ImpersonationPagingResult: any[] = [];
  ImpersonationPaging: PagingOptions;
  ImpersonationFilter: FilterItem;
  IsFilterLoaded: boolean = false;
  ProductionMode: boolean;
  PermissionSetList:any[]=[];
  ParticipantTypeList:any[]=[];
  @ViewChild('ImpersonationPagingViewElement', { static: false }) input: ElementRef;


  //Add Model Controls
  AddImpersonationForm = new FormGroup({});
  SourceParticipantType: DropdownOptions;
  DestinationParticipantType: DropdownOptions;
  SourcePermissionSetList: DropdownOptions;
  DestinationPermissionSetList: DropdownOptions;
  SourceUserAutoComplete: AutocompleteOptions;
  DestinationUserAutoComplete: AutocompleteOptions;
  IsActive: CheckBoxOptions;
  ExpiresAt: DatePickerOptions;
  ShowSourcePermissionList:boolean=false;
  ShowSourceUserAutoComplete:boolean=false;
  ShowDestinationPermissionList:boolean=false;
  ShowDestinationUserAutoComplete:boolean=false;
  @ViewChild('CloseImpersonationModal', { static: false }) CloseImpersonationModal: ElementRef;


  //Edit Model Controls
  EditImpersonationForm = new FormGroup({});
  EditSourceParticipantType: DropdownOptions;
  EditDestinationParticipantType: DropdownOptions;
  EditSourcePermissionSetList: DropdownOptions;
  EditDestinationPermissionSetList: DropdownOptions;
  EditSourceUserAutoComplete: AutocompleteOptions;
  EditDestinationUserAutoComplete: AutocompleteOptions;
  EditIsActive: CheckBoxOptions;
  EditExpiresAt: DatePickerOptions;
  EditShowSourcePermissionList:boolean=false;
  EditShowSourceUserAutoComplete:boolean=false;
  EditShowDestinationPermissionList:boolean=false;
  EditShowDestinationUserAutoComplete:boolean=false;
  ImpersonationId: number;
  SourceParticipantId: number;
  DestinationParticipantId: number;


  @ViewChild('CloseEditImpersonationModal', { static: false }) CloseEditImpersonationModal: ElementRef;

  

  //delete  Model Controls
  deleteImpersonationList: any[] = []
  @ViewChild('CloseDeleteImpersonationModal', { static: false }) CloseDeleteImpersonationModal: ElementRef;
  language:string=""
  // Decorator wires up blockUI instance
  ShowPageContent:boolean=false;

  constructor(private authService:AuthService,private pageInfoService:PageInfoService, public utilityService:UtilityService,private bbsfTranslateService:BBSFTranslateService,private environmentService:EnvironmentService, private ImpersonationRuleService: ImpersonationRuleService, private modalService: NgbModal) {
  }

  async ngOnInit(): Promise<void> {
    this.ShowPageContent=true;
    PageInfoService.PageTitle=this.utilityService.getResourceValue("ImpersonationRules")
    PageInfoService.PageBreadcrumbs=[
       {title: this.utilityService.getResourceValue("Home") , path: '/Admin/Home', isSeparator: false, isActive: false},
       {title: '', path: '', isSeparator: true, isActive: false}

    ];
    this.pageInfoService.calculateTitle();
    this.pageInfoService.calculateBreadcrumbs();
    this.bbsfTranslateService.onLangChange.subscribe((event)=>{
      this.language = event.lang;
      this.ngOnInit();
    })
    this.language = await this.utilityService.getCurrentLanguage();
    this.ProductionMode = this.environmentService.getProductionMode()
    this.LoadDropdownLists();
  }

  
  DestinationParticipant(key){
    let sourceItem=this.ParticipantTypeList.filter((item) => { return parseInt(item.key) == key; }).map((item) => item)[0];
     //console.log(sourceItem)

    switch (sourceItem.value) {
      case "PermissionSet":
        this.ShowDestinationPermissionList=true;
        this.ShowDestinationUserAutoComplete=false;
        

        
        break;
        case "User":
          this.ShowDestinationPermissionList=false;
        this.ShowDestinationUserAutoComplete=true;
       


        break;
    
      default:
        break;
    }
  
  }
  SourceParticipant(key){
    let sourceItem=this.ParticipantTypeList.filter((item) => { return parseInt(item.key) == key; }).map((item) => item)[0];
     //console.log(sourceItem)

    switch (sourceItem.value) {
      case "PermissionSet":
        this.ShowSourcePermissionList=true;
        this.ShowSourceUserAutoComplete=false;
        


        break;
        case "User":
        this.ShowSourcePermissionList=false;
        this.ShowSourceUserAutoComplete=true;
       

        break;
    
      default:
        break;
  }
}

EditDestinationParticipant(key){
  let sourceItem=this.ParticipantTypeList.filter((item) => { return parseInt(item.key) == key; }).map((item) => item)[0];
   //console.log(sourceItem)

  switch (sourceItem.value) {
    case "PermissionSet":
      this.EditShowDestinationPermissionList=true;
      this.EditShowDestinationUserAutoComplete=false;
     

      break;
      case "User":
      this.EditShowDestinationPermissionList=false;
      this.EditShowDestinationUserAutoComplete=true;


      break;
  
    default:
      break;
  }

}
EditSourceParticipant(key){
  let sourceItem=this.ParticipantTypeList.filter((item) => { return parseInt(item.key) == key; }).map((item) => item)[0];
   //console.log(sourceItem)

  switch (sourceItem.value) {
    case "PermissionSet":
      this.EditShowSourcePermissionList=true;
      this.EditShowSourceUserAutoComplete=false;
     
      break;
      case "User":
      this.EditShowSourcePermissionList=false;
      this.EditShowSourceUserAutoComplete=true;

      break;
  
    default:
      break;
}
}

  LoadDropdownLists() {
    this.ImpersonationRuleService.Loaddropdowns().subscribe((result) => {
      let DropdownLists = result as any
      this.PermissionSetList=DropdownLists.permissionList
      this.ParticipantTypeList=DropdownLists.participantTypeList

      // TextBox inti
      this.searchTextBox = new TextBoxOptions();
      this.searchTextBox.Name = "searchTextBox"
      this.searchTextBox.HideLabel = true
      this.searchTextBox.Type = InputType.Text
      this.searchTextBox.Placeholder = this.utilityService.getResourceValue("SearchByName")

      this.TextInputFilter = new FilterItem();
      this.TextInputFilter.FormControlName = "searchTextBox"
      this.TextInputFilter.ActionParameterName = "searchText"
      this.TextInputFilter.IsFormControl = true
      this.TextInputFilter.FilterType = FilterType.TextBox

      this.ImpersonationPaging = new PagingOptions();
      this.ImpersonationPaging.ActionPostURL = this.environmentService.getApiUrl() + this.ApiUrl + 'GetImpersonationRuleByFilter';
      this.ImpersonationPaging.OnKeyPressFiltersControlNames = ["searchTextBox"]
      this.ImpersonationPaging.Filters = [ this.TextInputFilter]
      this.ImpersonationPaging.ValidationToken = this.authService.authorizationHeaderValue()
      this.IsFilterLoaded = true;
      
    })
  }

  ReinitializeSectorPaging() {
    let element = this.input as any;
    element.ReinitializePaging();
  }

  UpdateSectorPaging() {
    let element = this.input as any;
    element.UpdatePaging();
  }

  setImpersonationListResult(result) {
    this.ImpersonationPagingResult= result
    this.ShowPageContent=true;
    this.utilityService.stopBlockUI()
  }

  resetFilters() {
    this.ImpersonationForm.controls["searchTextBox"].setValue(null);
    let element = this.input as any;
    element.ReinitializePaging();
  }

  showAddImpersonationModal(AddImpersonationModal) {
    this.AddImpersonationForm = new FormGroup({})

    this.ShowDestinationPermissionList=false;
    this.ShowDestinationUserAutoComplete=false;
    this.ShowSourcePermissionList=false
    this.ShowSourceUserAutoComplete=false
    this.utilityService.startBlockUI();

    this.SourceParticipantType = new DropdownOptions();
    this.SourceParticipantType.Name = "SourceParticipantType"
    this.SourceParticipantType.LabelKey = "SourceParticipantType"
    this.SourceParticipantType.SelectedItems = null;
    this.SourceParticipantType.DataSource = this.ParticipantTypeList
    this.SourceParticipantType.SingleSelection = true;
    this.SourceParticipantType.AllowSearchFilter = true;
    this.SourceParticipantType.IsRequired = true;

    this.DestinationParticipantType = new DropdownOptions();
    this.DestinationParticipantType.Name = "DestinationParticipantType"
    this.DestinationParticipantType.LabelKey = "DestinationParticipantType"
    this.DestinationParticipantType.SelectedItems = null;
    this.DestinationParticipantType.DataSource = this.ParticipantTypeList
    this.DestinationParticipantType.SingleSelection = true;
    this.DestinationParticipantType.AllowSearchFilter = true;
    this.DestinationParticipantType.IsRequired = true;

    this.SourcePermissionSetList = new DropdownOptions();
    this.SourcePermissionSetList.Name = "SourcePermissionSetList"
    this.SourcePermissionSetList.LabelKey = "SourcePermissionSetList"
    this.SourcePermissionSetList.SelectedItems = null;
    this.SourcePermissionSetList.DataSource = this.PermissionSetList
    this.SourcePermissionSetList.SingleSelection = true;
    this.SourcePermissionSetList.AllowSearchFilter = true;
    this.SourcePermissionSetList.IsRequired = true;

    this.DestinationPermissionSetList = new DropdownOptions();
    this.DestinationPermissionSetList.Name = "DestinationPermissionSetList"
    this.DestinationPermissionSetList.LabelValue = "DestinationPermissionSetList"
    this.DestinationPermissionSetList.LabelKey = "DestinationPermissionSetList"
    this.DestinationPermissionSetList.SelectedItems = null;
    this.DestinationPermissionSetList.DataSource = this.PermissionSetList
    this.DestinationPermissionSetList.SingleSelection = true;
    this.DestinationPermissionSetList.AllowSearchFilter = true;
    this.DestinationPermissionSetList.IsRequired = true;

    this.SourceUserAutoComplete = new AutocompleteOptions();
    this.SourceUserAutoComplete.Name = "SourceUserAutoComplete";
    this.SourceUserAutoComplete.LabelKey = "User";
    this.SourceUserAutoComplete.Type = InputType.Text;
    this.SourceUserAutoComplete.IsRequired = true;
    this.SourceUserAutoComplete.Value = null;
    this.SourceUserAutoComplete.ForceDirection = ForceDirection.English;
    this.SourceUserAutoComplete.ActionURL = this.environmentService.getApiUrl() + this.ApiUrl + "AutoCompleteUser"
    this.SourceUserAutoComplete.ValidationToken = this.authService.authorizationHeaderValue()

    this.DestinationUserAutoComplete = new AutocompleteOptions();
    this.DestinationUserAutoComplete.Name = "DestinationUserAutoComplete";
    this.DestinationUserAutoComplete.LabelKey = "User";
    this.DestinationUserAutoComplete.Type = InputType.Text;
    this.DestinationUserAutoComplete.IsRequired = true;
    this.DestinationUserAutoComplete.Value = null;
    this.DestinationUserAutoComplete.ActionURL = this.environmentService.getApiUrl() + this.ApiUrl + "AutoCompleteUser"
    this.DestinationUserAutoComplete.ValidationToken = this.authService.authorizationHeaderValue()
    
    this.IsActive = new CheckBoxOptions();
    this.IsActive.Name = "IsActive"
    this.IsActive.LabelKey = "Active"
    this.IsActive.IsDisabled = true
    this.IsActive.Value = true

    this.ExpiresAt = new DatePickerOptions();
    this.ExpiresAt.Name = "ExpiresAt"
    this.ExpiresAt.LabelKey = "ExpiresAt"
    this.ExpiresAt.IsRequired = true
    this.ExpiresAt.StartView = StartView.Month
    this.ExpiresAt.PickerType = PickerType.Calendar
    this.ExpiresAt.SelectMode=SelectMode.Single

    this.modalService.open(AddImpersonationModal);
    this.utilityService.stopBlockUI();

  }

  addImpersonation() {
  
      let ResultModel = this.AddImpersonationForm.value;

      let AddModel:ImpersonationRuleModel= new ImpersonationRuleModel() ;
      AddModel.SourceParticipantDTO.ParticipantTypeItemID=Number(ResultModel.SourceParticipantType)
      AddModel.DestinationParticipantDTO.ParticipantTypeItemID=Number(ResultModel.DestinationParticipantType)
      AddModel.ExpiresAt=ResultModel.ExpiresAt
      AddModel.IsActive=ResultModel.IsActive
      if(ResultModel.DestinationUserAutoComplete!=null&&ResultModel.DestinationUserAutoComplete!=undefined)
      AddModel.DestinationParticipantDTO.UserID=Number(ResultModel.DestinationUserAutoComplete.key)
      AddModel.DestinationParticipantDTO.PermissionSetID=Number(ResultModel.DestinationPermissionSetList)
      if(ResultModel.SourceUserAutoComplete!=null&&ResultModel.SourceUserAutoComplete!=undefined)
      AddModel.SourceParticipantDTO.UserID=  Number(ResultModel.SourceUserAutoComplete.key)
      AddModel.SourceParticipantDTO.PermissionSetID=Number(ResultModel.SourcePermissionSetList)

      this.ImpersonationRuleService.AddImpersonationRule(AddModel).subscribe((result) => {
        this.modalService.dismissAll();
        let element = this.input as any;
        element.ReinitializePaging();
      }, (error) => {
       
      })
  }


  showEditImpersonationModal(Impersonation: any, EditImpersonationModal) {
    this.EditImpersonationForm = new FormGroup({})

    this.EditShowDestinationPermissionList=false;
    this.EditShowDestinationUserAutoComplete=false;
    this.EditShowSourcePermissionList=false
    this.EditShowSourceUserAutoComplete=false

    if (Impersonation.sourceParticipantDTO.participantTypeItemID!=null&&Impersonation.destinationParticipantDTO.participantTypeItemID) {
      this.EditDestinationParticipant(Impersonation.destinationParticipantDTO.participantTypeItemID);
      this.EditSourceParticipant(Impersonation.sourceParticipantDTO.participantTypeItemID);
    }

    this.utilityService.startBlockUI();

    this.ImpersonationId=Impersonation.id;
    this.SourceParticipantId=Impersonation.sourceParticipantDTO.id;
    this.DestinationParticipantId=Impersonation.destinationParticipantDTO.id;
    this.EditSourceParticipantType = new DropdownOptions();
    this.EditSourceParticipantType.Name = "EditSourceParticipantType"
    this.EditSourceParticipantType.LabelKey = "SourceParticipantType"
    this.EditSourceParticipantType.SelectedItems = this.ParticipantTypeList.filter((item) => { return parseInt(item.key) == Impersonation.sourceParticipantDTO.participantTypeItemID; }).map((item) => item.key)[0];
    this.EditSourceParticipantType.DataSource = this.ParticipantTypeList
    this.EditSourceParticipantType.SingleSelection = true;
    this.EditSourceParticipantType.AllowSearchFilter = true;
    this.EditSourceParticipantType.IsRequired = true;

    this.EditDestinationParticipantType = new DropdownOptions();
    this.EditDestinationParticipantType.Name = "EditDestinationParticipantType"
    this.EditDestinationParticipantType.LabelKey = "DestinationParticipantType"
    this.EditDestinationParticipantType.SelectedItems = this.ParticipantTypeList.filter((item) => { return parseInt(item.key) == Impersonation.destinationParticipantDTO.participantTypeItemID; }).map((item) => item.key)[0];;
    this.EditDestinationParticipantType.DataSource = this.ParticipantTypeList
    this.EditDestinationParticipantType.SingleSelection = true;
    this.EditDestinationParticipantType.AllowSearchFilter = true;
    this.EditDestinationParticipantType.IsRequired = true;

    this.EditSourcePermissionSetList = new DropdownOptions();
    this.EditSourcePermissionSetList.Name = "EditSourcePermissionSetList"
    this.EditSourcePermissionSetList.LabelKey = "SourcePermissionSetList"
    this.EditSourcePermissionSetList.SelectedItems = this.PermissionSetList.filter((item) => { return parseInt(item.key) == Impersonation.sourceParticipantDTO.permissionSetID; }).map((item) => item.key)[0];;
    this.EditSourcePermissionSetList.DataSource = this.PermissionSetList
    this.EditSourcePermissionSetList.SingleSelection = true;
    this.EditSourcePermissionSetList.AllowSearchFilter = true;
    this.EditSourcePermissionSetList.IsRequired = true;

    this.EditDestinationPermissionSetList = new DropdownOptions();
    this.EditDestinationPermissionSetList.Name = "EditDestinationPermissionSetList"
    this.EditDestinationPermissionSetList.LabelKey = "DestinationPermissionSetList"
    this.EditDestinationPermissionSetList.SelectedItems = this.PermissionSetList.filter((item) => { return parseInt(item.key) == Impersonation.destinationParticipantDTO.permissionSetID; }).map((item) => item.key)[0];;;
    this.EditDestinationPermissionSetList.DataSource = this.PermissionSetList
    this.EditDestinationPermissionSetList.SingleSelection = true;
    this.EditDestinationPermissionSetList.AllowSearchFilter = true;
    this.EditDestinationPermissionSetList.IsRequired = true;

    this.EditSourceUserAutoComplete = new AutocompleteOptions();
    this.EditSourceUserAutoComplete.Name = "EditSourceUserAutoComplete";
    this.EditSourceUserAutoComplete.LabelKey = "User";
    this.EditSourceUserAutoComplete.Type = InputType.Text;
    this.EditSourceUserAutoComplete.IsRequired = true;


    let model=  new AutocompleteDTO();
    model.key=Impersonation.sourceParticipantDTO.userID
    model.value=Impersonation.sourceParticipantDTO.participantName.current;
    this.EditSourceUserAutoComplete.SelectedValue = model
    this.EditSourceUserAutoComplete.ActionURL = this.environmentService.getApiUrl() + this.ApiUrl + "AutoCompleteUser"
    this.EditSourceUserAutoComplete.ValidationToken = this.authService.authorizationHeaderValue()

    this.EditDestinationUserAutoComplete = new AutocompleteOptions();
    this.EditDestinationUserAutoComplete.Name = "EditDestinationUserAutoComplete";
    this.EditDestinationUserAutoComplete.LabelKey = "User";
    this.EditDestinationUserAutoComplete.Type = InputType.Text;
    this.EditDestinationUserAutoComplete.IsRequired = true;
    let DestinationUserModel=  new AutocompleteDTO();
    DestinationUserModel.key=Impersonation.destinationParticipantDTO.userID
    DestinationUserModel.value=Impersonation.destinationParticipantDTO.participantName.current;
    
    this.EditDestinationUserAutoComplete.SelectedValue =DestinationUserModel
    this.EditDestinationUserAutoComplete.ActionURL = this.environmentService.getApiUrl() + this.ApiUrl + "AutoCompleteUser"
    this.EditDestinationUserAutoComplete.ValidationToken = this.authService.authorizationHeaderValue()
    
    this.EditIsActive = new CheckBoxOptions();
    this.EditIsActive.Name = "EditIsActive"
    this.EditIsActive.LabelKey = "Active"
    this.EditIsActive.IsDisabled = true
    this.EditIsActive.Value = true

    this.EditExpiresAt = new DatePickerOptions();
    this.EditExpiresAt.Name = "EditExpiresAt"
    this.EditExpiresAt.LabelKey = "ExpiresAt"
    this.EditExpiresAt.IsRequired = true
    this.EditExpiresAt.Value = Impersonation.expiresAt
    this.EditExpiresAt.StartView = StartView.Month
    this.EditExpiresAt.PickerType = PickerType.Calendar
    this.EditExpiresAt.SelectMode=SelectMode.Single
    this.modalService.open(EditImpersonationModal);
    this.utilityService.stopBlockUI();


  }

  editImpersonation() {
    if (this.EditImpersonationForm.invalid) {
      return;
    }
    else {
      let ResultModel = this.EditImpersonationForm.value;

      let EditModel:ImpersonationRuleModel= new ImpersonationRuleModel() ;
      EditModel.ID=this.ImpersonationId
      EditModel.DestinationParticipantDTO.ID=this.DestinationParticipantId
      EditModel.SourceParticipantDTO.ID=this.SourceParticipantId
      EditModel.SourceParticipantDTO.ParticipantTypeItemID=Number(ResultModel.EditSourceParticipantType)
      EditModel.DestinationParticipantDTO.ParticipantTypeItemID=Number(ResultModel.EditDestinationParticipantType)
      EditModel.ExpiresAt=ResultModel.EditExpiresAt
      EditModel.IsActive = ResultModel.EditIsActive
      console.log("Data:");
      console.log(ResultModel);
      if (ResultModel.EditDestinationUserAutoComplete != null && ResultModel.EditDestinationUserAutoComplete != undefined)
        EditModel.DestinationParticipantDTO.UserID = Number(ResultModel.EditDestinationUserAutoComplete.key)
      EditModel.DestinationParticipantDTO.PermissionSetID=Number(ResultModel.EditDestinationPermissionSetList)
      if (ResultModel.EditSourceUserAutoComplete != null && ResultModel.EditSourceUserAutoComplete != undefined)
        EditModel.SourceParticipantDTO.UserID = Number(ResultModel.EditSourceUserAutoComplete.key)
      EditModel.SourceParticipantDTO.PermissionSetID=Number(ResultModel.EditSourcePermissionSetList)
      this.ImpersonationRuleService.EditImpersonationRule( EditModel).subscribe((result) => {
        this.modalService.dismissAll();
        let element = this.input as any;
        element.UpdatePaging();
      }, (error) => {
      })
    }
  }

  showDeleteImpersonationModal(Sector: any, deleteImpersonationModal) {
    this.deleteImpersonationList = []
    this.deleteImpersonationList.push(Sector);
    this.utilityService.startBlockUI();
    this.modalService.open(deleteImpersonationModal);
    this.utilityService.stopBlockUI();


  }

  deleteImpersonation() {
    let  UsersIDModel:UsersIDRequestModel= new UsersIDRequestModel() ;
     for (let index = 0; index < this.deleteImpersonationList.length; index++) {
       const element = this.deleteImpersonationList[index];
       UsersIDModel.UsersIDs.push(element.id)
       
     }
    this.ImpersonationRuleService.DeleteImpersonationRule(UsersIDModel ).subscribe((result) => {
      this.deleteImpersonationList = [];
      this.modalService.dismissAll();
      let element = this.input as any;
      element.ReinitializePaging();
    }, (error) => {
      
    })

  }


}
